import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import * as Business from "../../utils/business";

class Nav extends Component {
  state = {};

  render() {
    return (
      <ul className="nav">
        {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.CAR_UPLOAD_FILES,
          Business.ROLE_DEFINE_MAP.CAR_VIEW_REPORT,
          Business.ROLE_DEFINE_MAP.CAR_DELETE_REPORT,
        ]) && (
          <li
            className={
              this.isPathActive("/car") || this.state.carMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ carMenuOpen: !this.state.carMenuOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-note2"></i>
              <p>
                CAR <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.carMenuOpen}>
              <div>
                <ul className="nav">
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAR_UPLOAD_FILES,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/car/upload-file") ? "active" : null
                      }
                    >
                      <Link to="/car/upload-file">Upload File</Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAR_UPLOAD_FILES,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/car/file-management")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/car/file-management">File Management</Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAR_VIEW_REPORT,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/car/report-sa") ? "active" : null
                      }
                    >
                      <Link to="/car/report-sa">Report SA</Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAR_VIEW_REPORT,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/car/report-irb") ? "active" : null
                      }
                    >
                      <Link to="/car/report-irb">Report IRB</Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAR_VIEW_REPORT,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/car/report-basel") ? "active" : null
                      }
                    >
                      <Link to="/car/report-basel">Report Basel III</Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_UPLOAD_FILES]) && (
          <li
            className={
              this.isPathActive("/icaap") || this.state.icaapMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ icaapMenuOpen: !this.state.icaapMenuOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-cash"></i>
              <p>
                ICAAP <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.icaapMenuOpen}>
              <div>
                <ul className="nav">
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.ICAAP_UPLOAD_FILES,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/icaap/upload-file")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/icaap/upload-file">Upload File</Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.ICAAP_UPLOAD_FILES,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/icaap/file-management")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/icaap/file-management">File Management</Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.ICAAP_VIEW_REPORT,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/icaap/reports") ? "active" : null
                      }
                    >
                      <Link to="/icaap/reports">Reports</Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_SAVE,
          Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_VIEW_REPORT,
          Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_CALCULATE,
          Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_DELETE_REPORT,
        ]) && (
          <li
            className={
              this.isPathActive("/capital-planning") ||
              this.state.capitalPlanningMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({
                  capitalPlanningMenuOpen: !this.state.capitalPlanningMenuOpen,
                })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-graph2"></i>
              <p>
                Capital Planning<b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.capitalPlanningMenuOpen}>
              <div>
                <ul className="nav">
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_CALCULATE,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/capital-planning/dashboard")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/capital-planning/dashboard">Dashboard</Link>
                    </li>
                  )}
                  {Business.isHasRole([
                    Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_VIEW_REPORT,
                  ]) && (
                    <li
                      className={
                        this.isPathActive("/capital-planning/report")
                          ? "active"
                          : null
                      }
                    >
                      <Link to="/capital-planning/report">Report</Link>
                    </li>
                  )}
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {/* {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.RAROC_UPLOAD_FILES,
          Business.ROLE_DEFINE_MAP.RAROC_VIEW_REPORT,
          Business.ROLE_DEFINE_MAP.RAROC_DELETE_REPORT,
        ]) && ( */}
        <li
          className={
            this.isPathActive("/raroc") || this.state.rarocMenuOpen
              ? "active"
              : null
          }
        >
          <a
            onClick={() =>
              this.setState({ rarocMenuOpen: !this.state.rarocMenuOpen })
            }
            data-toggle="collapse"
          >
            <i className="pe-7s-diskette"></i>
            <p>
              RAROC <b className="caret"></b>
            </p>
          </a>
          <Collapse in={this.state.rarocMenuOpen}>
            <div>
              <ul className="nav">
                <li
                  className={
                    this.isPathActive("/raroc/upload-file") ? "active" : null
                  }
                >
                  <Link to="/raroc/upload-file">Upload File</Link>
                </li>
                <li
                  className={
                    this.isPathActive("/raroc/file-management")
                      ? "active"
                      : null
                  }
                >
                  <Link to="/raroc/file-management">File Management</Link>
                </li>
                <li
                  className={
                    this.isPathActive("/raroc/reports") ? "active" : null
                  }
                >
                  <Link to="/raroc/reports">Reports</Link>
                </li>
              </ul>
            </div>
          </Collapse>
        </li>
        {/* )} */}
        {/* {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.PRICING_UPLOAD_FILES,
          Business.ROLE_DEFINE_MAP.PRICING_VIEW_REPORT,
          Business.ROLE_DEFINE_MAP.PRICING_DELETE_REPORT,
        ]) && ( */}
        <li
          className={
            this.isPathActive("/pricing") || this.state.pricingMenuOpen
              ? "active"
              : null
          }
        >
          <a
            onClick={() =>
              this.setState({ pricingMenuOpen: !this.state.pricingMenuOpen })
            }
            data-toggle="collapse"
          >
            <i className="pe-7s-bookmarks"></i>
            <p>
              PRICING <b className="caret"></b>
            </p>
          </a>
          <Collapse in={this.state.pricingMenuOpen}>
            <div>
              <ul className="nav">
                <li
                  className={
                    this.isPathActive("/pricing/upload-file") ? "active" : null
                  }
                >
                  <Link to="/pricing/upload-file">Upload File</Link>
                </li>
                <li
                  className={
                    this.isPathActive("/pricing/file-management")
                      ? "active"
                      : null
                  }
                >
                  <Link to="/pricing/file-management">File Management</Link>
                </li>
                <li
                  className={
                    this.isPathActive("/pricing/pricing-result")
                      ? "active"
                      : null
                  }
                >
                  <Link to="/pricing/pricing-result">Pricing Result</Link>
                </li>
              </ul>
            </div>
          </Collapse>
        </li>
        <li
          className={
            this.isPathActive("/liquidity-ratio") ||
            this.state.liquidityRatioMenuOpen
              ? "active"
              : null
          }
        >
          <a
            onClick={() =>
              this.setState({
                liquidityRatioMenuOpen: !this.state.liquidityRatioMenuOpen,
              })
            }
            data-toggle="collapse"
          >
            <i className="pe-7s-diskette"></i>
            <p>
              Liquidity Ratio <b className="caret"></b>
            </p>
          </a>
          <Collapse in={this.state.liquidityRatioMenuOpen}>
            <div>
              <ul className="nav">
                <li>
                  <a
                    onClick={() =>
                      this.setState({
                        liquidityLCRMenuOpen: !this.state.liquidityLCRMenuOpen,
                      })
                    }
                    data-toggle="collapse"
                  >
                    <p>
                      LCR <b className="caret"></b>
                    </p>
                  </a>
                  <Collapse in={this.state.liquidityLCRMenuOpen}>
                    <div>
                      <ul className="nav">
                        <li
                          className={
                            this.isPathActive(
                              "/liquidity-ratio/lcr/upload-file"
                            )
                              ? "active"
                              : null
                          }
                        >
                          <Link
                            to="/liquidity-ratio/lcr/upload-file"
                            style={{ paddingLeft: 84 }}
                          >
                            Upload File
                          </Link>
                        </li>
                        <li
                          className={
                            this.isPathActive(
                              "/liquidity-ratio/lcr/file-management"
                            )
                              ? "active"
                              : null
                          }
                        >
                          <Link
                            to="/liquidity-ratio/lcr/file-management"
                            style={{ paddingLeft: 84 }}
                          >
                            File Management
                          </Link>
                        </li>
                        <li
                          className={
                            this.isPathActive("/liquidity-ratio/lcr/reports")
                              ? "active"
                              : null
                          }
                        >
                          <Link
                            to="/liquidity-ratio/lcr/reports"
                            style={{ paddingLeft: 84 }}
                          >
                            Reports
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Collapse>
                </li>
                <li>
                  <a
                    onClick={() =>
                      this.setState({
                        liquidityNFSRMenuOpen:
                          !this.state.liquidityNFSRMenuOpen,
                      })
                    }
                    data-toggle="collapse"
                  >
                    <p>
                      NSFR <b className="caret"></b>
                    </p>
                  </a>
                  <Collapse in={this.state.liquidityNFSRMenuOpen}>
                    <div>
                      <ul className="nav">
                        <li
                          className={
                            this.isPathActive(
                              "/liquidity-ratio/nfsr/upload-file"
                            )
                              ? "active"
                              : null
                          }
                        >
                          <Link
                            to="/liquidity-ratio/nfsr/upload-file"
                            style={{ paddingLeft: 84 }}
                          >
                            Upload File
                          </Link>
                        </li>
                        <li
                          className={
                            this.isPathActive(
                              "/liquidity-ratio/nfsr/file-management"
                            )
                              ? "active"
                              : null
                          }
                        >
                          <Link
                            to="/liquidity-ratio/nfsr/file-management"
                            style={{ paddingLeft: 84 }}
                          >
                            File Management
                          </Link>
                        </li>
                        <li
                          className={
                            this.isPathActive("/liquidity-ratio/nfsr/reports")
                              ? "active"
                              : null
                          }
                        >
                          <Link
                            to="/liquidity-ratio/nfsr/reports"
                            style={{ paddingLeft: 84 }}
                          >
                            Reports
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </Collapse>
                </li>
              </ul>
            </div>
          </Collapse>
        </li>
        {/* )} */}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.EDIT_PARAMETERS]) && (
          <li
            className={
              this.isPathActive("/master-table") ||
              this.state.masterTableMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({
                  masterTableMenuOpen: !this.state.masterTableMenuOpen,
                })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-plugin"></i>
              <p>
                Master Table <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.masterTableMenuOpen}>
              <div>
                <ul className="nav">
                  <li
                    className={
                      this.isPathActive("/master-table/party-type")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/master-table/party-type">Party Type</Link>
                  </li>
                  {/* <li
                    className={
                      this.isPathActive("/master-table/business-sector")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/master-table/business-sector">
                      Business Sector
                    </Link>
                  </li> */}
                  <li
                    className={
                      this.isPathActive("/master-table/loan-purpose-type")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/master-table/loan-purpose-type">
                      Loan Purpose Type
                    </Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/master-table/collateral-master")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/master-table/collateral-master">
                      Collateral Type
                    </Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/master-table/product-type")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/master-table/product-type">Product Type</Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/master-table/capital-buffer")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/master-table/capital-buffer">
                      Capital Buffer
                    </Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.DISABLE]) && (
          <li
            className={
              this.isPathActive("/config") || this.state.configMenuOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ configMenuOpen: !this.state.configMenuOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-config"></i>
              <p>
                Config Parameters <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.configMenuOpen}>
              <div>
                <ul className="nav">
                  <li
                    className={
                      this.isPathActive("/config/components") ? "active" : null
                    }
                  >
                    <Link to="/config/components">Components</Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/config/asset-class") ? "active" : null
                    }
                  >
                    <Link to="/config/asset-class">Asset Class</Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/config/risk-weight") ? "active" : null
                    }
                  >
                    <Link to="/config/risk-weight">Risk Weight</Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.DISABLE]) && (
          <li
            className={
              this.isPathActive("/dashboard") || this.state.dashboardOpen
                ? "active"
                : null
            }
          >
            <a
              onClick={() =>
                this.setState({ dashboardOpen: !this.state.dashboardOpen })
              }
              data-toggle="collapse"
            >
              <i className="pe-7s-graph"></i>
              <p>
                Dashboard <b className="caret"></b>
              </p>
            </a>
            <Collapse in={this.state.dashboardOpen}>
              <div>
                <ul className="nav">
                  <li
                    className={
                      this.isPathActive("/dashboard/car") ? "active" : null
                    }
                  >
                    <Link to="/dashboard/car">CAR</Link>
                  </li>
                  <li
                    className={
                      this.isPathActive("/dashboard/credit-risk")
                        ? "active"
                        : null
                    }
                  >
                    <Link to="/dashboard/credit-risk">Credit Risk</Link>
                  </li>
                </ul>
              </div>
            </Collapse>
          </li>
        )}
        {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.CREATE_USER,
          Business.ROLE_DEFINE_MAP.UPDATE_USER,
          Business.ROLE_DEFINE_MAP.DELETE_USER,
        ]) && (
          <li className={this.isPathActive("/user") ? "active" : null}>
            <Link to="/user">
              <i className="pe-7s-users"></i>
              <p>User</p>
            </Link>
          </li>
        )}
        {Business.isHasRole([
          Business.ROLE_DEFINE_MAP.CREATE_ROLE,
          Business.ROLE_DEFINE_MAP.UPDATE_ROLE,
        ]) && (
          <li className={this.isPathActive("/role") ? "active" : null}>
            <Link to="/role">
              <i className="pe-7s-id"></i>
              <p>Role</p>
            </Link>
          </li>
        )}
        {Business.isHasRole([Business.ROLE_DEFINE_MAP.NO_ROLE]) && (
          <li className={this.isPathActive("/activities") ? "active" : null}>
            <Link to="/activities">
              <i className="pe-7s-target"></i>
              <p>Activities</p>
            </Link>
          </li>
        )}
      </ul>
    );
  }

  isPathActive(path) {
    if (this.props.location.pathname.startsWith(path)) {
      console.log(this.props.location.pathname);
    }
    return this.props.location.pathname.startsWith(path);
  }
}

export default withRouter(Nav);



// WEBPACK FOOTER //
// ./src/components/SideBar/Nav.js